import { httpClient } from "@bw/shared/api";
import type { Schema } from "@bw/shared/types/generated";

export type GamificationSummary = Schema["GamificationSummaryResponse"];
export type GamificationAchievement =
  Schema["GamificationAchievementProgressResponse"];
export type GamificationSelection =
  Schema["GamificationCosmeticSelectionResponse"];
export type PublicGamification = Schema["PublicGamificationResponse"];

export const gamificationApi = {
  mine: () => httpClient.get<GamificationSummary>("/gamification/me"),
  public: (userId: string) =>
    httpClient.get<PublicGamification>(
      `/gamification/players/${encodeURIComponent(userId)}`,
    ),
  selectCosmetics: (
    selection: GamificationSelection,
    update: Pick<
      GamificationSelection,
      | "profile_accent"
      | "avatar_ring"
      | "featured_achievement_key"
      | "show_streak_publicly"
    >,
  ) =>
    httpClient.put<GamificationSelection>("/gamification/me/cosmetics", {
      ...update,
      expected_revision: selection.revision,
      idempotency_key: crypto.randomUUID(),
    }),
  setAchievementVisibility: (
    achievement: GamificationAchievement,
    visibility: GamificationAchievement["visibility"],
  ) =>
    httpClient.put<GamificationAchievement>(
      `/gamification/me/achievements/${encodeURIComponent(achievement.key)}/visibility`,
      {
        visibility,
        expected_revision: achievement.revision,
        idempotency_key: crypto.randomUUID(),
      },
    ),
};
